import React from 'react';
import { LinearProgress } from '@material-ui/core';
import useStyles from './styles';

export default function PageLoading() {
  const classes = useStyles();

  return (
    <div className={classes.boxLoading}>
      <h1 align="center">Please wait, this might take a while.</h1>
      <LinearProgress variant="query" />
    </div>
  );
}
